
export default {
  methods: {
    findPage(pages, id) {
      for (const page of pages) {
        if (page.id === id) return page

        if (page.children)  {
          const childPage = this.findPage(page.children, id)
          if (childPage) return childPage
        }
      }
    },
  },
  computed: {
    activePage() {
      return this.findPage(this.pages, this.page)
    },
    currentPage() {
      const active = this.activePage
      const page = active && (active.to || active.id)
      const link = this.link

      return (page && link + page) || link + `${link}/${this.pageUrl}`
    },
  },
}
